module.exports = __webpack_public_path__ + "static/media/InvolvedXs4.baef39ad.svg";